import { useQuery } from "react-query";
import { RestError } from "../../../services/rest-service/RestService";
import { IGroupByAttribute } from "../../../services/summary-listing-data-service/DeviceSummaryModels";
import SummaryListingDataService from "../../../services/summary-listing-data-service/SummaryListingDataService";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseDeviceSummaryGroupByAttributeDataParameters = {
    groupID: number,
    attributeName: string | undefined;
} & BaseUseQueryParameters<IGroupByAttribute[]>;

export function useDeviceGroupByAttributeData({

    groupID,
    attributeName,
    enabled,
    onError,
    onSuccess,
    //refreshSeconds
}: UseDeviceSummaryGroupByAttributeDataParameters) {
    return useQuery<IGroupByAttribute[], RestError>(
        keys.groupByAttributeData(groupID, attributeName),
        ({ signal }) => {
            if (attributeName) {
                return SummaryListingDataService.getGroupByAttributeData(groupID, attributeName, signal);
            } else {
                return Promise.resolve([]);
            }
        },
        {
            enabled,
            onError,
            onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
